import { Flex } from 'antd'
import Icon from '@/components/icon'
import Styles from './style.module.scss'

const TITLE = 'After-sales Support'
const data = [
  {
    title: 'Address',
    description: '780 MONTAGUE\nEXPRESS WAY UNIT1101, SAN\nJOSE, CA 95131',
  },
  {
    title: 'Contact information',
    description: '541-91362892\n408-476-9312',
  },
  {
    title: 'Email',
    description: 'info@carusg.com',
  },
]

export default function AfterSale() {
  return (
    <Flex vertical align='center' className={Styles.afterSale}>
      <Icon name='call' className={Styles.icon} />
      <h5>{TITLE}</h5>
      <Flex justify='space-around' className={Styles.gridCard}>
        {data.map((item, index) => (
          <>
            <div key={item.title} className={Styles.card}>
              <div className={Styles.title}>{item.title}</div>
              <Flex align='center' justify='center' className={Styles.description}>
                {item.description}
              </Flex>
            </div>
            {index !== data.length - 1 && <div className={Styles.divider} />}
          </>
        ))}
      </Flex>
    </Flex>
  )
}
